import { useEffect, useState, useRef } from 'react'
import { useGLTF, Environment } from '@react-three/drei'
import { SceneChild, BoundingBoxesMap } from '../types/portfolio_types'
import { getAppleData } from '../store/localstorageData'
import * as THREE from 'three'
import { interactable_mushroom_room_objects } from '../interactable_data/mushroom_house_data'
import {
  floorLoadedAtom,
  pickedApplesAtom,
  currentInteractionAtom,
  boundingBoxesMapAtom,
  showHelpersAtom,
  justPickedApplesAtom,
  availableInteractableObjectAtom,
} from '../store/store'
import { useAtom } from 'jotai'
import AppleSparkles from './AppleSparkles'
import { deepDispose } from '../helpers/deepDispose'
import { useFrame, useThree } from '@react-three/fiber'
import { getBoxIntersection, removeAllHelpersFromScene, resolvePenetration } from '../helpers/helperFunctions'

const APPLE_UNDER_BED = 'apple020'
type BallObj = { mesh: THREE.Object3D; collider: THREE.Sphere; velocity: THREE.Vector3; name: string }
type ChairObj = { mesh: THREE.Object3D; collider: THREE.Box3; velocity: THREE.Vector3 }

// For some reason, this bg doesn't load (throws an error) on m1 Mac's Firefox.
// So, the easier thing is to define it as a base64 image here. It's only 2kb.
const ROOM_BG =
  'data:image/png;base64,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'

const MushroomHouseInterior = () => {
  const model = useGLTF('/models/portfolio_forest/mushroom_house_interior.glb')
  const [sceneChildren, setSceneChildren] = useState<SceneChild[]>([])
  const [sceneClone, setSceneClone] = useState<THREE.Object3D<THREE.Object3DEventMap>>()

  const [floorLoaded, setFloorLoaded] = useAtom(floorLoadedAtom)
  const [currentInteractionObj] = useAtom(currentInteractionAtom)
  const [pickedApples, setPickedApples] = useAtom(pickedApplesAtom)
  const [justPickedApples, setJustPickedApples] = useAtom(justPickedApplesAtom)

  const [interactableObject, setInteractableObject] = useAtom(availableInteractableObjectAtom)

  const pulled_apple = useRef(false)

  const chair_ref = useRef<ChairObj>()
  const apple_ref = useRef<BallObj>()

  const [bbMap, setBbMap] = useAtom(boundingBoxesMapAtom)
  const [showHelpers] = useAtom(showHelpersAtom)
  const { scene } = useThree()

  const vector1 = useRef(new THREE.Vector3())
  const vector2 = useRef(new THREE.Vector3())
  const vector3 = useRef(new THREE.Vector3(0, 1, 0))

  // const pointLightRef = useRef<THREE.PointLight>(null)
  // useHelper(pointLightRef, THREE.PointLightHelper, 1, 'red')

  // 1) CLONE THE SCENE SO IT DOESN'T GO AWAY WHEN WE UNMOUNT
  useEffect(() => {
    if (sceneClone) return
    // SET MIN FILTER IN THE TEXTURES THAT REQUIRE IT
    const room_material = model.materials.room_material as THREE.MeshStandardMaterial
    room_material.map!.minFilter = THREE.LinearFilter

    setSceneClone(model.scene.clone(true))
  }, [model, sceneClone])

  // 2) CREATE THE BOUNDING BOXES MAP + Apple sphere + HELPERS FOR DEV MODE
  useEffect(() => {
    if (!sceneClone) return

    const boundingBoxesMap: BoundingBoxesMap = {}
    const objects_without_bodies_lax = [
      'pillow',
      'room_walls',
      'cherry_blossom_tree_leaves',
      'flowerpot',
      'plant_trunk',
      'pacman',
      'book',
      'rug',
      'door_tunnel',
      'shadows',
      'house_monitor',
      'the_tower_100',
      'keyboard',
      'mouse',
      'notebook',
      'dumbbell',
      'game_controller',
      'arcade_stick',
      'drawing_tablet',
      'apple',
    ]
    const objects_without_bodies_specific = [
      'bed',
      'handrail',
      'stair001',
      'stair002',
      'stair003',
      'stair004',
      'stair005',
      'mysterious_door',
    ]
    const receive_shadow_objects = [
      'bed',
      'bed_frame_1',
      'bed_frame_2',
      'room_floor',
      'room_walls',
      'rug',
      'handrail',
      'stair001',
      'stair002',
      'stair003',
      'stair004',
      'stair005',
      'mysterious_door',
      'doorknob',
    ]

    for (const child of sceneClone.children) {
      if (receive_shadow_objects.find((objName) => child.name.toLowerCase() === objName)) {
        child.receiveShadow = true
        child.children.forEach((obj) => {
          obj.receiveShadow = true
        })
      }

      if (child.name === APPLE_UNDER_BED) {
        const SPHERE_RADIUS = 0.5

        apple_ref.current = {
          mesh: child,
          collider: new THREE.Sphere(child.position, SPHERE_RADIUS),
          velocity: new THREE.Vector3(),
          name: child.name,
        }
      }

      if (
        objects_without_bodies_lax.find((objName) => child.name.toLowerCase().includes(objName)) ||
        objects_without_bodies_specific.find((objName) => child.name.toLowerCase() === objName)
      ) {
        continue
      }

      const { name } = child
      const bbox = new THREE.Box3().setFromObject(child)

      if (child.name === 'office_chair') {
        chair_ref.current = {
          mesh: child,
          collider: bbox,
          velocity: new THREE.Vector3(),
        }
      }

      if (name === 'carton_box') {
        bbox.min.x += 0.7
        bbox.max.x -= 0.7
        bbox.min.z += 1.2
        bbox.max.z -= 0.9
      }

      if (name === 'office_chair') {
        bbox.min.x += 0.7
        bbox.max.x -= 0.7
        bbox.min.z += 0.9
        bbox.max.z -= 0.5
      }

      let type: 'sensor' | 'collision' = 'collision'
      let color = 'yellow'

      if (name.startsWith('sensor_')) {
        type = 'sensor'
        color = 'crimson'
      }

      if (name.includes('apple')) {
        color = '#41b94b'
      }

      boundingBoxesMap[name] = { name, bbox, type }

      if (showHelpers) {
        const boxHelper = new THREE.Box3Helper(bbox, color)
        boxHelper.name = `helper_${name}`
        scene.add(boxHelper)
      }

      // INTERACTION SENSORS
      if (
        interactable_mushroom_room_objects[name] &&
        !interactable_mushroom_room_objects[name].skip_setting_position
      ) {
        interactable_mushroom_room_objects[name].position = child.position
      }
    }

    setBbMap(boundingBoxesMap)
    setFloorLoaded(true)
  }, [sceneClone, setBbMap, scene, showHelpers, setFloorLoaded])

  // 3) Populate scene children
  useEffect(() => {
    if (sceneChildren.length || !sceneClone) return

    const processedSceneChildren = sceneClone.children.map((child) => {
      return {
        object: child,
        element: <primitive object={child} key={child.id} />,
        interactable: interactable_mushroom_room_objects[child.name],
      }
    })

    setSceneChildren(processedSceneChildren)
  }, [sceneChildren, sceneClone])

  // 4) Set picked apples
  useEffect(() => {
    if (!pickedApples) {
      setPickedApples(getAppleData())
    }
  }, [pickedApples, setPickedApples])

  // 5) Save picked apples to local storage
  useEffect(() => {
    if (!pickedApples) return
    localStorage.setItem('apples', JSON.stringify(pickedApples))
  }, [pickedApples])

  // 6) Listener: Pull apple from under the bed
  useEffect(() => {
    if (!currentInteractionObj) return

    const { currentInteraction, currentlyInspecting } = currentInteractionObj

    if (
      currentInteraction.id === 'not_picked_apple' &&
      currentlyInspecting.id === 'sensor_bed' &&
      apple_ref.current &&
      !pulled_apple.current
    ) {
      apple_ref.current.velocity.x += 2

      setTimeout(() => {
        pulled_apple.current = true
      }, 1500)
    }
  }, [currentInteractionObj])

  // 7) DISPOSE OBJECTS ON UNMOUNT
  useEffect(() => {
    return () => {
      if (!floorLoaded || !sceneChildren.length) return

      removeAllHelpersFromScene(scene)
      setBbMap(null)
      setSceneClone(undefined)
      setSceneChildren([])
      sceneChildren.forEach((child) => deepDispose(child.object))
    }
  }, [sceneChildren, floorLoaded, scene, setBbMap])

  // 8) Random bug where sometimes upon entering the house
  // the interactable object of the door will still be active.
  useEffect(() => {
    if (interactableObject?.id === 'sensor_house_door') {
      setInteractableObject(null)
    }
  }, [interactableObject, setInteractableObject])

  const pickApple = (apple_name: string) => {
    if (!pickedApples || pickedApples.list[APPLE_UNDER_BED]) return

    const apple_data = getAppleData()
    const updated_apples = { ...apple_data }

    if (updated_apples.list[apple_name] === false) {
      updated_apples.collected += 1
      updated_apples.list[apple_name] = true

      setPickedApples(updated_apples)
      setJustPickedApples({
        ...justPickedApples,
        [apple_name]: true,
      })
    }
  }

  const getSparkles = () => {
    if (!apple_ref.current || !justPickedApples || !justPickedApples[APPLE_UNDER_BED]) return null

    return <AppleSparkles position={apple_ref.current.mesh.position} />
  }

  // Bounciness goes from 1 to 2.
  const GRAVITY = 0.1
  const BOUNCINESS = 1.6

  const updateApple = (delta: number) => {
    if (!bbMap || !apple_ref.current) return

    const ball = apple_ref.current
    ball.collider.center.addScaledVector(ball.velocity, delta)

    for (const bb_key in bbMap) {
      const { type, bbox, name } = bbMap[bb_key]
      if (type !== 'collision') continue

      const intersects = ball.collider.intersectsBox(bbox)

      if (intersects) {
        // 1) Find the closest point on the box to the sphere center
        const closestPoint = bbox.clampPoint(ball.collider.center, vector1.current)

        // 2) Compute normal from box surface to sphere center
        const normal = ball.collider.center.clone().sub(closestPoint).normalize()

        // 3) Compute penetration depth
        const distance = ball.collider.center.distanceTo(closestPoint)
        const penetrationDepth = ball.collider.radius - distance

        if (penetrationDepth > 0) {
          //4)  Reflect the velocity along the collision normal
          const velocityDot = ball.velocity.dot(normal)

          // 5) Bounce factor
          const randomness = 1 + (Math.random() - 0.5) * 0.1
          ball.velocity.addScaledVector(normal, -velocityDot * BOUNCINESS * randomness)

          // 6) Push the ball out of the box surface
          ball.collider.center.add(normal.multiplyScalar(penetrationDepth))

          if (name === 'bianca') {
            pickApple(ball.name)
          }
        }
      } else {
        ball.velocity.y -= GRAVITY * delta
      }
    }

    ball.mesh.position.copy(ball.collider.center)

    // ADD ROTATION
    const horizontalVelocity = ball.velocity.clone()
    horizontalVelocity.y = 0

    const speed = horizontalVelocity.length()

    // Ignore very small velocities to avoid jitter
    if (speed > 0.0001) {
      // Rotation axis is perpendicular to movement direction (right-hand rule)
      const rotationAxis = vector2.current.crossVectors(vector3.current, horizontalVelocity).normalize()

      // Angle = distance moved / radius (like real rolling)
      const angle = (speed * delta) / ball.collider.radius

      ball.mesh.rotateOnWorldAxis(rotationAxis, angle)
      vector2.current.set(0, 0, 0)
    }
  }

  const updateChair = (delta: number) => {
    if (!bbMap || !chair_ref.current) return

    const chair = chair_ref.current

    // Move collider based on velocity
    const velocityDelta = chair.velocity.clone().multiplyScalar(delta)
    chair.mesh.position.add(velocityDelta)

    // Update collider box based on mesh position
    chair.collider.setFromObject(chair.mesh)
    chair.collider.min.x += 0.7
    chair.collider.max.x -= 0.7
    chair.collider.min.z += 0.9
    chair.collider.max.z -= 0.5

    for (const bb_key in bbMap) {
      const { type, bbox, name } = bbMap[bb_key]
      if (type !== 'collision' || name === 'office_chair') continue

      const intersection = getBoxIntersection(chair.collider, bbox)

      if (intersection) {
        const resolved = resolvePenetration(chair.collider, bbox, chair.mesh)

        if (resolved) {
          // 7) Add an additional impact if Bianca is the one pushing it
          if (name === 'bianca') {
            const obstacleCenter = bbox.getCenter(new THREE.Vector3())
            const chairCenter = chair.collider.getCenter(new THREE.Vector3())

            const normal = chairCenter.clone().sub(obstacleCenter)
            normal.y = 0
            normal.normalize()
            const PUSH_STRENGTH = 0.015

            // Apply directional push
            chair.velocity.addScaledVector(normal, PUSH_STRENGTH)
          } else {
            // Reflect velocity on the axis of penetration with a damping/bounce effect
            chair.velocity[resolved.axis] *= -0.3

            // Prevent the chair from getting stuck on a wall
            if (name.includes('barrier_room_wall_bottom')) {
              chair.velocity.z = -1
            } else if (name.includes('barrier_room_wall_right')) {
              chair.velocity.x = -1
            } else if (name.includes('barrier_room_wall_left')) {
              chair.velocity.x = 1
            }
          }
        }
      } else {
        // Apply gravity
        chair.velocity.y -= GRAVITY * delta
      }
    }

    // ADD Y-AXIS ROTATION BASED ON VELOCITY
    const horizontalVelocity = chair.velocity.clone()
    horizontalVelocity.y = 0

    const speed = horizontalVelocity.length()

    if (speed > 0.0001) {
      // Compute target Y angle from velocity direction
      const targetAngle = Math.atan2(horizontalVelocity.x, horizontalVelocity.z)

      // Normalize current and target angle to avoid spinning the long way around
      const currentAngle = chair.mesh.rotation.y
      let angleDiff = targetAngle - currentAngle

      // Keep angleDiff within [-PI, PI] for shortest path
      angleDiff = ((angleDiff + Math.PI) % (2 * Math.PI)) - Math.PI

      // Apply a smaller interpolation factor for slower turning
      const turnSpeed = 0.002 // smaller = slower turning
      chair.mesh.rotation.y += angleDiff * turnSpeed
    }
  }

  useFrame((_state, delta) => {
    if (!apple_ref.current || !bbMap) return

    const safeDelta = Math.min(delta, 0.01)

    updateApple(safeDelta)
    updateChair(safeDelta)
  })

  const renderScene = () => {
    const filteredScene = sceneChildren.filter((child) => {
      if (child.object.name === APPLE_UNDER_BED && pickedApples?.list[APPLE_UNDER_BED]) {
        return false
      }

      return !(child.object.name.startsWith('barrier_') || child.object.name.startsWith('sensor_'))
    })

    return filteredScene.map((child) => child.element)
  }

  return (
    <group>
      {renderScene()}
      {getSparkles()}

      {/* Lights */}
      <pointLight
        // ref={pointLightRef}
        color={'#cbad25'}
        castShadow={false}
        position={[6, 6.5, -1]}
        intensity={25}
        shadow-mapSize={[1024, 1024]}
        shadow-camera-near={1}
        shadow-camera-far={10}
        shadow-camera-top={10}
        shadow-camera-right={10}
        shadow-camera-bottom={-10}
        shadow-camera-left={-10}
      />

      <directionalLight
        color={'#ffffff'}
        castShadow={false}
        position={[-7, 10, 10]}
        intensity={1.3}
        shadow-mapSize={[1024, 1024]}
        shadow-camera-near={1}
        shadow-camera-far={10}
        shadow-camera-top={10}
        shadow-camera-right={10}
        shadow-camera-bottom={-10}
        shadow-camera-left={-10}
      />

      <Environment
        background
        resolution={512}
        files={[ROOM_BG, ROOM_BG, ROOM_BG, ROOM_BG, ROOM_BG, ROOM_BG]}
      />
    </group>
  )
}

export default MushroomHouseInterior

useGLTF.preload('/models/portfolio_forest/mushroom_house_interior.glb')
